/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import {AlarmRules, AlarmRuleController} from './alarm-rules.directive';

export default angular.module('tektelic.alarmRules', [])
    .directive('tkAlarmRules', AlarmRules)
    .controller('AlarmRuleController', AlarmRuleController)
    .name;



// WEBPACK FOOTER //
// ./src/app/alarm-rule/index.js